module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/16 nizky rostenec vcelku.jpg";